module.exports = __webpack_public_path__ + "img/nophoto.e02663e5.png";